import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

interface CompactCasinoCardProps {
  index: number;
  id?: string;
  logo: string;
  welcomeBonusText?: string;
  freeBonusText?: string;
  refURL: string;
  allowedCountries: string;
  flag: string;
  country?: string;
}

const CompactCasinoCard = (props: CompactCasinoCardProps) => {
  const { t } = useTranslation();
  const [allowed, setAllowed] = useState<boolean>(false);
  const {
    logo,
    welcomeBonusText,
    freeBonusText,
    refURL,
    index,
    flag,
    allowedCountries,
    country,
  } = props;
  let dealOfTheWeek = false;
  if (index === 0) {
    dealOfTheWeek = true;
  }

  useEffect(() => {
    if (country) {
      const allowedCountriesArray = allowedCountries
        .split(",")
        .map((c) => c.trim().toLowerCase());
      setAllowed(allowedCountriesArray.includes(country.toLowerCase()));
    }
  }, [allowedCountries, country]);
  return (
    <div
      key={index}
      className={`relative grid w-full md:grid-cols-5 min-h-[12rem] gap-4 py-3 ${
        dealOfTheWeek ? "border-3 !border-[#1b9c36]" : "border-0"
      } ${index % 2 === 0 ? "bg-[#3a3a3a]" : "bg-[#2a2a2a]"}`}
    >
      {dealOfTheWeek && (
        <div className="absolute -top-8 right-0 bg-[#1b9c36] text-white px-4 py-1">
          {t("deal_of_the_week")}
        </div>
      )}

      <div className="flex w-full h-full items-center justify-center">
        <img
          src={logo}
          alt="Preview"
          className="w-[12rem] md:h-[7rem] object-fit"
        />
      </div>

      {/* <div className="h-full flex flex-col justify-center items-center">
        <div className="text-white text-xl lg:text-[2.5rem] font-defaultFont text-center">
          {welcomeBonusText}
        </div>
        <div className="lg:text-xl mt-2 text-center">{freeBonusText}</div>
      </div> */}
      <div className="h-full flex flex-col justify-center items-center">
        <div className="text-white text-xl lg:text-[2rem] font-defaultFont text-center">
          {welcomeBonusText}
        </div>
        <div className="text-[0.7rem] lg:text-[0.9rem] mt-2 text-center">
          {freeBonusText}
        </div>
      </div>

      <div className="flex justify-center items-center space-x-1">
        {[...Array(5)].map((_, i) => (
          <svg
            key={i}
            className={`w-[2rem] h-[2rem] ${
              i < 5 ? "text-yellow-400" : "text-gray-600"
            }`}
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.964a1 1 0 00.95.69h4.188c.969 0 1.371 1.24.588 1.81l-3.39 2.464a1 1 0 00-.364 1.118l1.286 3.964c.3.921-.755 1.688-1.538 1.118L10 14.347l-3.39 2.464c-.783.57-1.838-.197-1.538-1.118l1.286-3.964a1 1 0 00-.364-1.118L2.606 9.391c-.783-.57-.381-1.81.588-1.81h4.188a1 1 0 00.95-.69l1.286-3.964z" />
          </svg>
        ))}
      </div>

      <h2 className="flex font-bold justify-center items-center w-full text-center text-[0.8rem]">
        {flag && (
          <img alt="Flag" src={flag} className="mr-3 w-[20px] h-[20px]" />
        )}
        {allowed ? "You Can Play" : "You Cannot Play"}
      </h2>

      <div className="w-full flex justify-center items-center">
        <button
          onClick={() => window.open(refURL, "_blank")}
          disabled={!allowed}
          className={`px-4 py-4 text-center text-white rounded-3xl font-bold text-[0.8rem] lg:text-[1.5rem] z-10 ${
            allowed
              ? "cursor-pointer animate-radiate bg-[#1b9c36]"
              : "cursor-not-allowed hover:animate-shake bg-red-500/40"
          } `}
        >
          {t("receive_bonus")}
        </button>
      </div>
    </div>
  );
};

export default CompactCasinoCard;
